angular.module('impactx.invoice').controller('InvoiceCorrectionNewItemCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    'OutsourcedCommentSaveService',
    'blhId',
    'pdneId',
    'copyId',
    'copyType',
    'createCopy',
    InvoiceCorrectionNewItemCtrl
]);

function InvoiceCorrectionNewItemCtrl($scope, dataGen, $mdDialog, ToastService, TranslationService, OutsourcedCommentSaveService,
                                      blhId, pdneId, copyId, copyType, createCopy) {
    var ctrl = this;

    function getData() {
        $scope.trns = {
            save: TranslationService.get('save'),
            abort: TranslationService.get('abort'),
            required: TranslationService.get('required'),
        };
        if(createCopy) {
            getCopyData();
        }
        else {
            dataGen.getData($scope, {blhId: blhId, pdneId: pdneId}, '/invoice/complaint/correction/newitem');
        }
    };

    function getCopyData() {
        if (copyType === 'PDNE') {
            dataGen.getData($scope, {blhId: blhId, pdneId: copyId}, '/invoice/complaint/correction/newitem/copy/pdne');
        }
        else if (copyType === 'DNI') {
            dataGen.getData($scope, {blhId: blhId, dniId: copyId}, '/invoice/complaint/correction/newitem/copy/dni');
        }
    }

    ctrl.checkRequireCtrl = function (type) {
        let ctrlElem = $scope.data.control[type];
        if (ctrlElem) {
            return ctrlElem.showMust;
        }
        return false;
    };

    ctrl.changeAAT = function (aatId) {
        var dataObj = {
            aatId: aatId,
            item: $scope.data,
            blhId: blhId
        };
        dataGen.postAsForm({}, dataObj, "/complaint/correction/newitem/changeaat").then(function (response) {
            if (response && response.data) {
                $scope.data.control = response.data.control;
            }
        })
    };

    ctrl.save = function () {
        var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data);
        dataGen.postAsForm({}, {data: $scope.data}, '/invoice/complaint/correction/newitem/save').then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments, true).then(function () {
                    ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                    $mdDialog.hide();
                });
            }
            else {
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                $mdDialog.hide();
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments($scope.data, extractedComments);
        })
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    getData();
}